export const fetchOnboardingState = (currentShopId, currentOnboarding, signal) => (
    fetch(`/api/onboarding/${currentShopId}/${currentOnboarding}`, {signal})
        .then((res) => [res.status, res.json()])
);